<template>
  <b-modal ref="modal"
           size="lg"
           centered
           @close="$emit('close')"
           @shown="onShow">
    <template #modal-header>
      <div class="d-flex align-items-center col-12">
        <img src="https://static.zopone.com.br/img/logotipo/header/zopone.png" style="width: 45px" />
        <span class="modalTitle ml-auto">
          {{$lang.PCI.Considerations.Title}}
        </span>
        <button class="close" @click="onHide">x</button>
      </div>
    </template>
    <template #modal-footer>
      <div class="d-flex justify-content-end col-12">
        <b-button variant="primary" @click="onSave">{{ $lang.Common.Buttons.Save }}</b-button>
      </div>
    </template>
    <div>
      <v-select v-model="contract"
                label="referenciaContrato"
                :clearable="false"
                class="m-1 mb-3 text-center"
                :options="contracts"
                @input="onLoadContract"></v-select>
    </div>
    <b-form-textarea ref="input" v-model="considerations.consideracoes" :rows="10"></b-form-textarea>
  </b-modal>
</template>

<script>
import { loading, toast } from '@/shared/utils/UIHelper'
import WorkPCIRepository from '@/shared/http/repositories/pci/workpci'
export default {
  name: 'Considerations',
  data () {
    return {
      contracts: [],
      contract: {},
      considerations: {}
    }
  },
  mounted () {
  },
  methods: {
    show (contracts) {
      this.contracts = contracts
      this.contract = contracts[0]
      this.onLoadContract()
    },
    onLoadContract () {
      loading.push()
      WorkPCIRepository.GetConsiderations(this.contract.contratoId)
        .then(response => {
          if (response.data.code > 0) {
            this.considerations = response.data.data
            this.$refs.modal.show()
          } else {
            toast.error(this.$lang.Common.Alerts.Error)
          }
        })
        .catch(err => {
          console.log(err)
          toast.error(this.$lang.Commom.Alerts.Error)
        })
        .finally(() => loading.close())
    },
    onShow () {
      this.$refs.input.$el.focus()
    },
    onHide () {
      this.$refs.modal.hide()
      this.$emit('close')
    },
    onSave () {
      loading.push()
      WorkPCIRepository.SaveConsiderations(this.considerations)
        .then(response => {
          if (response.data.code > 0) {
            this.considerations = response.data.data
          } else {
            toast.error(this.$lang.Common.Alerts.Error)
          }
        })
        .catch(err => {
          console.log(err)
          toast.error(this.$lang.Commom.Alerts.Error)
        })
        .finally(() => loading.close())
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/components/considerations/considerations.vue